import { AlertTriangle, X } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

/** Shown when a link (e.g. from "Несоответствия") names an item this page cannot find. */
export function DeepLinkMissing({
  missingId,
  what,
  onDismiss,
}: {
  missingId: string | null
  /** Nominative, e.g. "Пункт затрат", "Вопрос". */
  what: string
  onDismiss: () => void
}) {
  if (!missingId) return null
  return (
    <Alert>
      <AlertTriangle />
      <AlertTitle className="flex items-center justify-between gap-2">
        {what} не найден
        <Button variant="ghost" size="sm" onClick={onDismiss} aria-label="Скрыть">
          <X />
        </Button>
      </AlertTitle>
      <AlertDescription>
        Запись <code className="font-mono text-xs">{missingId}</code> не найдена: возможно, её уже
        удалили или она недоступна для чтения.
      </AlertDescription>
    </Alert>
  )
}
